import lockIcon from "../../medias/lockIcon.svg";
import userIcon from "../../medias/userIcon.svg";
import { Container, Typography } from "@mui/material";
import { CriticalError } from "../CriticalError";
import { 
    Group,
    InputButton,
    InputField,
    showComplexSnackbarDispatcher,
    showSnackbar,
 } from "../../components/";
import { Loading } from "../Loading";
import { Page } from "../Page";
import { apiClient } from "../../api/";
import { styles } from "../../theme/";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

/**
 * SignUp page
 */
export const SignUp = () => {
    // Hooks
    const navigate = useNavigate();

    // useStates
    const [criticalError, setCriticalError] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [password, setPassword] = useState<string>("");

    // Handlers
    const handleCreateAccount = async () => {
        setLoading(true);

        try {
            const [response, statusOk] = await apiClient.signUp(email.toLocaleLowerCase(), password);

            if (statusOk) {
                showSnackbar({ message: `Account successfully created.`, variant: "success" });
                showSnackbar({ message: `Verify your email.`, variant: "success" });
                navigate("/signIn?to=/needsEmailVerification");

            } else {
                setError(true);
                showComplexSnackbarDispatcher(response as { [key: string]: string[]; });
            }

        } catch (error) {
            setCriticalError(true);
            showSnackbar({ message: String(error), variant: "error" });

        } finally {
            await new Promise(resolve => setTimeout(resolve, 1000));
            setLoading(false);
        }
    };

    // Early return
    if (criticalError) return <CriticalError />;

    return (
        <Page >
            <Loading show={loading} />
            <Container style={styles.inPlaceModal} >
                <Typography style={{ fontFamily: "ArchivoBlack", fontSize: 36 }} >Sign Up</Typography>
                <InputField type="email" value={email} leftIcon={userIcon} placeholder={"Email"} error={error} setValue={setEmail} />
                <InputField type="password" value={password} leftIcon={lockIcon} leftIconSize="100%" placeholder={"Password"} error={error} setValue={setPassword} submitAction={() => handleCreateAccount()} />
                {/* <div style={{
                    border: `2px solid ${colors.background.error}`,
                    borderRadius: 15,
                    display: "flex",
                    padding: "20px 0px",
                    width: "100%",
                }}>
                    <div style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        paddingLeft: 20,
                    }}>
                        <ErrorOutlineIcon /><Typography>Test</Typography>
                    </div>
                </div> */}
                <Group direction="row">
                    <InputButton type="main" onClick={() => navigate(-1)} tooltip="Go back">Back</InputButton>
                    <InputButton type="secondary" onClick={() => handleCreateAccount()} tooltip="Create account">Create account</InputButton>
                </Group>
            </Container>
        </Page >
    );
};